<template>
  <div class="revise-box">
    <el-form ref="deptform" :model="deptform" label-width="120px" class="user-form">
      <el-form-item label="部门名称:">
        <el-input v-model="deptform.name" placeholder="部门名称" class="user-input" />
      </el-form-item>

      <el-form-item label="上级部门:">
        <el-cascader
          ref="lastdept"
          v-model="lastParent"
          :show-all-levels="false"
          :options="lastdeptList"
          :props="optionProps"
          class="user-input"
          placeholder="一级部门"
          @change="handleItemChange"
        />
      </el-form-item>

      <el-form-item label="排序号:">
        <el-input-number v-model="deptform.orderNum" :min="0" :max="1000" class="user-input" />
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click.prevent="save">确定</el-button>
        <el-button type="warning" @click.prevent="back">返回</el-button>
      </el-form-item>
    </el-form>

  </div>
</template>

<script>
export default {
	    data() {
    return {
      lastdeptList: [
      ],

      optionProps: {
        expandTrigger: 'hover',
        emitPath: false,
        value: 'deptId',
        label: 'name',
        children: 'children'
      },

      deptform: {
        deptId: '',
        name: '',
        orderNum: 0,
        parentId: 0,
        parentName: ''
      },

      lastParent: []
    }
	    },

  created() {
    this.$emit('setCurrentMenu', '部门管理')
    this.getlastdept()
    this.getcurrentdept()
  },

	    methods: {

    getlastdept() {
      const vm = this
      vm.axios.get(this.homePath() + '/sys/dept/select')
        .then(res => {
          if (res.data.status == '000000') {
            const data = res.data.deptList
            vm.lastdeptList = vm.filterNull(vm.toTreeData(data, 'parentId', 'deptId'))
          } else {
            this.$alert(res.data.message, '提示')
          }
        })
        .catch(error => console.log(error))
    },

    filterNull(data) {
      const vm = this
      for (var i = 0; i < data.length; i++) {
				    if (data[i].children.length < 1) {
				        data[i].children = undefined
				    } else {
				        vm.filterNull(data[i].children)
				    }
      }
      return data
    },

    getcurrentdept() {
      const vm = this
      const deptId = vm.$route.params.id
      vm.deptform.deptId = deptId
      vm.axios.get(this.homePath() + '/sys/dept/info/' + deptId)
        .then(response => {
          const data = response.data
          if (data.status == '000000') {
            vm.deptform.name = data.dept.name
            vm.deptform.parentId = data.dept.parentId
            vm.deptform.parentName = data.dept.parentName
            vm.deptform.orderNum = data.dept.orderNum
            vm.lastParent = data.dept.parentId
          }
        })
        .catch(error => console.log(error))
    },

    handleItemChange(val) {
      this.deptform.parentId = val
      this.deptform.parentName = this.$refs['lastdept'].getCheckedNodes()[0].label
    },

    save() {
      let past = true
      if (this.deptform.name == '') {
        this.$alert('部门名称', '提示')
        past = false
      }

      if (past) {
        const vm = this
        vm.axios.post(vm.homePath() + '/sys/dept/update', {
          deptId: vm.deptform.deptId,
          name: vm.deptform.name,
          parentId: vm.deptform.parentId,
          parentName: vm.deptform.parentName,
          orderNum: vm.deptform.orderNum
        })
          .then(response => {
            if (response.data.status == '000000') {
              this.$alert('修改成功', '提示', {
                callback: action => {
                  this.$router.push('/index/dept')
                }
              })
            } else {
              console.log(response.data.message)
            }
          })
          .catch(error => console.log(error))
      }
    },

    back() {
      this.$router.push('/index/dept')
    }
	    }
	  }
</script>

<style>
</style>

